import { render } from "./PostalCodeDrawer.vue?vue&type=template&id=7d0cf64d&scoped=true"
import script from "./PostalCodeDrawer.vue?vue&type=script&lang=js"
export * from "./PostalCodeDrawer.vue?vue&type=script&lang=js"

import "./PostalCodeDrawer.vue?vue&type=style&index=0&id=7d0cf64d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0cf64d"]])

export default __exports__